import { render } from "./EquipementLabo.vue?vue&type=template&id=45663ba5&scoped=true"
import script from "./EquipementLabo.vue?vue&type=script&lang=js"
export * from "./EquipementLabo.vue?vue&type=script&lang=js"

import "./EquipementLabo.vue?vue&type=style&index=0&id=45663ba5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45663ba5"]])

export default __exports__